<template>
  <div class="section">
    <div class="container">
      <h1>Enforceability Index (non-CTC countries)</h1>
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-input placeholder="Search for country" type="search" icon="search" v-model="search"></b-input>
        </div>
        <div class="column is-9"></div>
        <div class="column is-12">
          <b-table :data="Countries" mobile-cards default-sort-direction="desc" default-sort="Score" :row-class="HighlightBG">
            <b-table-column field="Group" label="Country" sortable v-slot="props">
              <img class="flag-small" :src="getFlag(props.row.LogoPath)" />
              <a @click="goToCountryIndex(props.row.GroupId)">{{ props.row.Group }}</a>
            </b-table-column>
            <b-table-column field="Score" label="Score" sortable v-slot="props">
              {{ props.row.Score > 0 ? props.row.Score : "" }}
            </b-table-column>
            <b-table-column field="Category" label="Category" sortable v-slot="props">
              <span v-if="!props.row.IsSpecialNotice">
                {{ props.row.Score != 0 ? props.row.Category : "Unscored" }}
              </span>
              <span v-if="props.row.IsSpecialNotice">Special Notice</span>
            </b-table-column>
            <b-table-column field="QualifyingDeclarations" label="" sortable v-slot="props">
              <span v-if="props.row.Score != 0">
                <a href="javascript://" @click="print(props.row)">
                  <strong>
                    <span v-show="CFTAccess(props.row.GroupId)">
                      <i class="fad fa-download"></i>
                      &nbsp;Download Certified Version
                    </span>
                    <span v-show="!CFTAccess(props.row.GroupId)">
                      <i class="fad fa-shopping-basket"></i>
                      &nbsp;Order
                    </span>
                  </strong>
                </a>
                &nbsp;
                <span v-show="props.row.printing">
                  <i class="far fa-spinner-third fa-spin"></i>
                </span>
              </span>
            </b-table-column>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Role from "@/roles";
  export default {
    data() {
      return {
        data: [],
        search: "",
        loading: false,
      };
    },
    computed: {
      Countries() {
        return this.filteredData;
      },
      filteredData() {
        return this.data.filter((option) => {
          if (option.Group.toString().toLowerCase().indexOf(this.search.toLowerCase()) >= 0) {
            return option.Group.toString().toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
          }
        });
      }
    },
    methods: {
      getFlag(path) {
        if (!path) return;
        return require("@/assets/images/countryLogos/" + path);
      },
      HighlightBG(row, index) {
        switch (row.Category) {
          case "Very High": {
            return "is-vhigh-category";
          }
          case "High": {
            return "is-high-category";
          }
          case "Medium": {
            return "is-medium-category";
          }
          case "Low": {
            if (row.Score > 0) {
              return "is-low-category";
            } else {
              return "is-no-score";
            }
          }
        }
      },
      CFTAccess() {
        if (this.$store.getters.user) {
          return this.$store.getters.user.Roles.some(
            (r) =>
              r == Role.Admin || r == Role.Enhanced || r == Role.AWGMember || r == Role.CFTPackage
          );
        }
        return false;
      },
      goToCountryIndex(id) {
        if (id == "a70fc607-1f3b-4957-8734-134da9cdfda0") {
          this.$router.push("/enforceabilityIndex/" + id);
        } else if (
          (this.$store.getters.user &&
            this.$store.getters.user.Groups &&
            this.$store.getters.user.Groups.some((r) => r == id)) ||
          (this.$store.getters.user &&
            this.$store.getters.user.Roles &&
            this.$store.getters.user.Roles.some(
              (r) =>
                r == Role.Admin || r == Role.Enhanced || r == Role.Standard || r == Role.AWGMember
            ))
        ) {
          this.$router.push("/enforceabilityIndex/" + id);
        } else {
          this.$router.push("/restricted");
        }
      },
      Refresh() {
        this.loading = true;
        return this.$http
          .get("api/group/index/enforceability/list")
          .then((resp) => {
            //console.log(resp.data);
            resp.data.forEach((item) => {
              this.$set(item, "printing", false);
            });
            this.data = resp.data;
            this.loading = false;
            return resp.data;
          })
          .catch((err) => {
            this.loading = false;
          });
      },
      print(group) {
        if (this.CFTAccess(group.GroupId)) {
          this.$set(group, "printing", true);
          this.loading = true;
          this.$http
            .get("api/group/index/enforceability/" + group.GroupId)
            .then((r) => {
              var country = r.data;
              return this.$http({
                method: "post",
                url: "api/print/enforceability/scorecard",
                data: { enforceability: country },
                responseType: "arraybuffer"
              }).then((resp) => {
                let blob = new Blob([resp.data]);
                var filename = "".concat(country.Name, " Enforceability ", country.Period, ".pdf");

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                  var link = document.createElement("a");
                  link.href = window.URL.createObjectURL(blob);
                  link.setAttribute("download", filename);
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }
              });
            })
            .catch((err) => {
              this.$buefy.toast.open("An error occurred while getting the group's information.");
            })
            .finally(() => {
              this.loading = false;
              this.$set(group, "printing", false);
            });
        } else {
          this.$router.push({
            name: "checkout",
            params: { productId: this.CFTDownloadId, updatesRole: true, groupId: group.GroupId }
          });
        }
      },
    },
    created() {
      this.Refresh();
    },
    mounted() {
      // This lifecycle hook is called when the component is mounted
    },
  }
</script>
